// src/config/theme.js
import * as palette from "./colors";

const theme = {
  colors: {
    // Paleta atual (mantém compatibilidade)
    ...palette,

    // ===== Semânticos base =====
    appBackground: palette.primaryDarkColor,
    sidebarBackground: palette.primaryDarkColor,
    topbarBackground: palette.primaryDarkColor,

    surface: "#ffffff",
    border: "rgba(0, 0, 0, 0.08)",

    textPrimary: "#111111",
    textMuted: "#666666",

    textOnAppBackground: palette.lightBgText,
    textMutedOnAppBackground: palette.lightGrayColor,

    primary: palette.primaryColor,
    primarySoft: palette.primaryColorLight,
    primarySoftHover: palette.primaryColorLightHover,
    onPrimarySoft: palette.onPrimaryLightColor,
    onPrimary: "#ffffff",

    // ===== Status (com alias pro typo existente) =====
    success: palette.sucessColor,
    successColor: palette.sucessColor, // alias "certo" sem quebrar legado
    info: palette.infoColor,
    infoHover: palette.infoColorHover,
    danger: palette.errorColor,
    dangerHover: palette.errorColorHover,
    warning: palette.warningColor,

    // ===== FC7: ações, links e apoio (.claude/rules/fc7-design-system.md) =====
    actionWrite: palette.actionWriteColor,
    actionWriteHover: palette.actionWriteColorHover,
    ctaDark: palette.ctaDarkColor,
    ctaDarkHover: palette.ctaDarkColorHover,
    dangerSoft: "rgba(171, 32, 32, 0.08)",
    dangerBorder: "rgba(171, 32, 32, 0.35)",
    link: palette.linkColor,
    linkHover: palette.linkColorHover,
    focusRing: "rgba(24, 95, 165, 0.25)",
    // Tokens já referenciados com fallback no Routing — valores IGUAIS aos fallbacks:
    surfaceMuted: "#eef1f5",
    borderLight: "rgba(0, 0, 0, 0.06)",
    textInfo: palette.linkColor,

    // ===== Tokens p/ Shell (fundo escuro) =====
    borderOnAppBackground: "rgba(255, 255, 255, 0.08)",
    controlBorderOnAppBackground: "rgba(255, 255, 255, 0.14)",
    controlHoverOnAppBackground: "rgba(255, 255, 255, 0.08)",
    backdrop: "rgba(0, 0, 0, 0.35)",
  },

  shadows: {
    sm: "0 1px 2px rgba(0,0,0,0.04)",
  },
};

export default theme;
